export default ({ i18n, app }) => {
  app.vuetify.framework.lang.current = i18n.locale
  i18n.onLanguageSwitched = (ـ, newLocale) => {
    app.vuetify.framework.lang.current = newLocale
  }
}
